const OPERATOR_DELIMITER = '__';

/**
 * Removes the operator prefix from our event, market and selection ids.
 * For example: `4__12345` becomes `12345`
 * @param id The id to normalize, event, market or selection id
 * @returns The normalized id, without the operator prefix
 */
const normalizeUnifiedId = (id: string) => {
	if (id == null) {
		return id;
	}

	const operatorIndex = id.indexOf(OPERATOR_DELIMITER);
	if (operatorIndex > -1) {
		return id.substring(operatorIndex + 2);
	}

	return id;
};

export default normalizeUnifiedId;
